export default {
  feature: {
    tags: false,
    dataTransfer: false,
    creditAlarm: false,
    budgetAlarm: false,
    costByRegion: false,
    costByCountry: true,
    globalCorporation: true,
  },

  billing: {
    cdn: {
      enabled: false,
    },
    dataTransfer: {
      enabled: false,
    },
    alarm: {
      enabled: false,
    },
    consolidated: {
      enabled: true,
    },
    costPivot: {
      enabled: false,
    },
    costTrend: {
      enabled: false,
    },
  },

  currencies: {
    default: 'USD',
    cny: {
      enabled: true,
    },
  },

  corporations: {
    international: {
      enabled: true,
    },
    china: {
      enabled: true,
    },
    australia: {
      enabled: true,
    },
  },

  timezone: 'Asia/Shanghai',

  ga: {
    hasGoogleAnalytics: true,
    trackingId: 'G-SH6BE50TEH',
  },
}
